import { ExternalLink } from 'lucide-react'

import CopyWithTooltip from '@/common/CopyWithTooltip'
import { getScanAddressUrl, getScanValidatorUrl } from '@/helpers/explorer'
import { formatAddress } from '@/helpers/formatters'
import { cn } from '@/theme/utils'

type Props = {
  address: string

  variant?: 'address' | 'validator'

  className?: string
  linkClassName?: string

  showFull?: boolean
  start?: number
  end?: number
}

export default function UiAddressExplorerCopy({
  address,
  variant = 'address',
  className,
  linkClassName,
  showFull = false,
  start = 6,
  end = 6,
}: Props) {
  const display = showFull ? address : formatAddress(address, start, end)

  const explorerUrl =
    variant === 'validator'
      ? getScanValidatorUrl(address)
      : getScanAddressUrl(address)

  return (
    <div className={cn('inline-flex items-center gap-2', className)}>
      {(() => {
        if (!explorerUrl) {
          return <span className={cn('text-sm', linkClassName)}>{display}</span>
        }

        return (
          <a
            href={explorerUrl}
            className={cn('text-sm', linkClassName)}
            target='_blank'
            rel='noreferrer noopener'
          >
            {display}
          </a>
        )
      })()}

      {explorerUrl && (
        <a
          href={explorerUrl}
          className={cn('text-primary')}
          target='_blank'
          rel='noreferrer noopener'
          aria-label='Open in explorer'
        >
          <ExternalLink className='size-4' />
        </a>
      )}

      <CopyWithTooltip value={address} />
    </div>
  )
}
